import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from '../../helpers/axios';
import { showError } from "../../helpers/Notifications/Notification";
import SurveyServerResposne from "../../models/SurveyServerResponse";

export const organizationChartThunk = createAsyncThunk(
    'super-admin/spiderchart',
    async (payload, thunkAPI) => {
        try {
            
            const response = await Promise.all([
                api.get(`client/spider-chart/?survey_id=${payload.surveyId}`),
                api.get(`client/master-data/?type=mils`),
                api.get(`client/crr-results/?survey_id=${payload.surveyId}`),
                api.get(`client/crr-results/?survey_id=all&limit=3&org_id=${payload.orgId}`)
            ]);

            return response;
        } catch(error) {
            return error;
        }
    }
)

export const yearsDropdownThunk = createAsyncThunk(
    'super-admin/years',
    async (payload, thunkAPI) => {
        try {
            const response = await api.get(`admin/survey-years/?organization_id=${payload.organizationId}`)
            return response.data;
        } catch(error) {
            return error;
        }
    }
)

export const surveysDropdownThunk = createAsyncThunk(
    'super-admin/survey',
    /**
     * 
     * @param {*} payload 
     * @param {*} thunkAPI 
     * @returns {Promise<SurveyServerResposne>}
     */
    async (payload, thunkAPI) => {
        try {
            const response = await api.get(
                `admin/all-survey/?organization_id=${payload.organizationId}&year=${payload.year}`
            )
            return response.data;
        } catch(error) {
            return error;
        }
    }
)

const organizationSurveyTabSlice = createSlice({
    name: 'OrganizationSurveyTab',
    initialState: {
        isChatLoading: false,
        isYearsLoading: false,
        isSurveysLoading: false,
        chartData: [],
        years: [],
        surveys: [],
    },
    extraReducers: {
        [organizationChartThunk.fulfilled]: (state, action) => {
            state.chartData = action.payload;
            state.isChatLoading = false;
        },
        [organizationChartThunk.pending]: (state, action) => {
            state.isChatLoading = true
        },
        [organizationChartThunk.rejected]: (state, action) => {
            state.isChatLoading = false;
            showError('Something went wrong');
        },
        [yearsDropdownThunk.fulfilled]: (state, action) => {
            state.years = action.payload.data;
            state.isYearsLoading = false;
        },
        [yearsDropdownThunk.pending]: (state, action) => {
            state.isYearsLoading = true;
            state.isChatLoading = true
            state.isSurveysLoading = true;
        },
        [yearsDropdownThunk.rejected]: (state, action) => {
            state.isYearsLoading = false;
            showError('Something went wrong');
        },
        [surveysDropdownThunk.fulfilled]: (state, action) => {
            state.isSurveysLoading = false;
            state.surveys = action.payload.data;
        },
        [surveysDropdownThunk.pending]: (state, action) => {
            state.isSurveysLoading = true;
            state.isChatLoading = true
        },
        [surveysDropdownThunk.rejected]: (state, action) => {
            state.isSurveysLoading = false;
            console.error(action.payload);
            showError('Something went wrong');
        },
    },
    reducers: {
        clearOrganizationSurveyTabState: (state) => {
            state.isChatLoading = false;
            state.isYearsLoading = false;
            state.isSurveysLoading = false;
            state.chartData = [];
            state.years = [];
            state.surveys = [];
        }
    }
})

export const { clearOrganizationSurveyTabState } = organizationSurveyTabSlice.actions;

export const organizationSurveyTabSelector = (state) => state.organizationSurveyTab;

export default organizationSurveyTabSlice.reducer;
